import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ColorsPickerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${props => props.theme.spacing.sp40};

  & > div > div > div:first-child {
    min-width: ${props => props.theme.size.L};
    min-height: ${props => props.theme.size.L};
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const PreviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
